<template>
  <div>
    <v-footer padless class="font-weight-medium mt-10 px-10">
      <v-card tile flat width="100%" class="transparency">
        <v-card-text class="px-0">
          <!--
          <v-row>
            <v-col>
              <v-row>
                <v-col class="d-flex justify-center">
                  <span class="body-1">Would you like to find out more?</span>
                </v-col>
              </v-row>
              
              <v-row justify="center">
                <v-btn color="primary" class="af-link" dark tile depressed :to="{name: 'contact'}">
                  Request Demo
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          -->
          <v-divider></v-divider>

          <v-row>
            <v-col cols="12" sm="12" md="12" lg="2" class="pl-10">
              <v-row>
                <v-col>
                  <img src="@/assets/text-logo.png" alt width="158" />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <small class="d-block caption mb-3 text-muted">
                    C-8-31, Centum @ Oasis Corporate Park, Jalan PJU 1A/2, Ara Damansara, 47301 Petaling Jaya, Selangor
                    <br />
                    <br />P: +60 (13) 288 4462
                    <br />E:
                    <a href="mailto:info@accelefreight.com">info@accelefreight.com</a>
                  </small>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="1"></v-col>

            <v-col>
              <v-row>
                <v-col>
                  <v-list class="transparency pt-0">
                    <span class="title">Why us</span>
                    <v-list-item class="af-link" :to="{name: 'webaboutus'}">
                      <v-list-item-content>
                        <v-list-item-title class="text-muted body-2">Our Story</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="af-link" :to="{name: 'comingsoon'}">
                      <v-list-item-content>
                        <v-list-item-title class="text-muted body-2">Features</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>

                <v-col>
                  <v-list class="transparency pt-0">
                    <span class="title">Services</span>
                    <v-list-item class="af-link" :to="{name: 'webourservices'}">
                      <v-list-item-content>
                        <v-list-item-title class="text-muted body-2">Our Services</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>

                <v-col>
                  <v-list class="transparency pt-0">
                    <span class="title">Resources</span>
                    <v-list-item class="af-link" :to="{name: 'webfaq'}">
                      <v-list-item-content>
                        <v-list-item-title class="text-muted body-2">FAQ</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>

                <v-col>
                  <v-list class="transparency pt-0">
                    <span class="title">Company</span>
                    <!-- <v-list-item class="af-link" :to="{name: 'webaboutus'}">
                      <v-list-item-content>
                        <v-list-item-title class="text-muted body-2">About Us</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>-->

                    <v-list-item class="af-link" :to="{name: 'contact'}">
                      <v-list-item-content>
                        <v-list-item-title class="text-muted body-2">Contact Us</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="1"></v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row class="px-4">
            <!-- <v-col cols="12" sm="12" md="12" lg="3" class="pl-4">
              <v-row>
                <v-btn small fab outlined depressed color="primary" href="#" class="af-link mx-2">
                  <v-icon color="primary">mdi-facebook</v-icon>
                </v-btn>

                <v-btn small fab outlined depressed color="primary" href="#" class="af-link mx-2">
                  <v-icon color="primary">mdi-linkedin</v-icon>
                </v-btn>

                <v-btn small fab outlined depressed color="primary" href="#" class="af-link mx-2">
                  <v-icon color="primary">mdi-twitter</v-icon>
                </v-btn>

                <v-btn small fab outlined depressed color="primary" href="#" class="af-link mx-2">
                  <v-icon color="primary">mdi-instagram</v-icon>
                </v-btn>
              </v-row>
            </v-col>-->

            <v-col class="d-flex justify-end">
              <span>&copy; Copyright AcceleFreight 2020</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
export default {};
</script>

<style >
.transparency {
  background-color: transparent !important;
}

.v-list-item--link:before {
  background-color: transparent !important;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>